import React from "react"
import NewHeader from "../components/layout/NewHeader"
import { Controls } from "../components/layout/menu_help"
import Modal from "../components/layout/modal"
import Popups from "../components/layout/popup"
import Questions from "../components/layout/questions"
import { defPath } from "../config/defPath"
import { useSession } from "../hooks/useState"
import VideosPopUp from "../components/layout/videoPopUp"
import useLocalStorage from "../hooks/useLocalData"
import { PopsController } from "../classes/popsController"
import { type TLocalData } from "../../../@types/global"

window.dataLayer = window.dataLayer || [];

function App() {
  const [isAcceptAge, setIsAcceptAge] = React.useState(false)

  const { items, deleteItem } = useLocalStorage<TLocalData>()

  React.useEffect(() => {
    const age = window.localStorage.getItem("ageGateValidate")

    if (age) setIsAcceptAge(true)


  }, [])

  React.useEffect(() => {
    if (Object.keys(items).length === 0) return
    if (window.drupalSettings && window.drupalSettings.user.uid.length) {
      if (items['predicciones']) {
        fetch(`${window.origin}/aguila/loyalty/send/predictions`, {
          method: "POST",
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(items['predicciones'])
        })
          .then(res => res.json())
          .then(data => {
            if (data[0].message === "SUCCESS") {
              setTimeout(() => {
                items['predicciones'].length && items['predicciones'].forEach(((prediction: any) => {
                  window.dataLayer.push({
                    'event': 'GAEvent',
                    'event_category': 'Content',
                    'event_action': 'Button',
                    'event_label': `${prediction.nameHome}_${prediction.nameAway} - ${prediction.league}`,
                    'interaction': 'true',
                    'component_name': 'Modo_Carrera_Predictions',
                    'element_text': 'Guardar Marcadores',
                  });
                }))
                window.openAlert({
                  title: "Predicciones Guardadas",
                  desc: "Haz clic aquí para editar",
                  href: '/estadio-aguila/predicciones'
                })
                if (data[0].popup) {
                  setTimeout(() => {
                      window.openAlert({
                          title: `${data[0].popup}`,
                          time: 6000
                      })
                  }, 6000)
                }
              }, 10000);
            }
          }).finally(() => {
            deleteItem("predicciones")
          })
      }
      if (items['tada']) {
        setTimeout(() => {

          const { tada_code } = items['tada'] as { tada_code: string }
          fetch(`${window.origin}/aguila/loyalty/tadacode`, {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ tada_code })
          })
            .then(res => res.json())
            .then(data => {

              if (data.total) {
                useSession.setState({ coins: parseInt(data.total.coins) })
                useSession.setState({ points: parseInt(data.total.points) })
              }

              if(data.redirect) {
                window.location.href = data.redirect
                return
            }

              new PopsController().open('tada', data)

              if (data.popup) {
                setTimeout(() => {
                    window.openAlert({
                        title: `${data.popup}`,
                        time: 6000
                    })
                }, 6000)
            }

            }).finally(() => {
              deleteItem("tada")
            })
        }, 10000);

      }
    }

  }, [items])

  return (
    <>
      <section id='king-home'>

        <img className="iconStars" src={`${defPath}/assets/images/icons/iconStars.png`} alt="" />
        
        <div id="deviceRotated">
          <span>
            <img src={`${defPath}/assets/images/deviceRotated.svg`} />
            Rota tu dispositivo.
          </span>
        </div>

        <div className='loader'>
          <div className='loader-ball'>&nbsp;</div>
          <span className='loader-value'>0%</span>
        </div>

        <NewHeader />
        <Modal />
        <Controls isStadium={true} />
        <Questions />
        <Popups />

        {/* { !window.sessionStorage.getItem('btnStartClicked') && (
          <VideosPopUp  />
        )} */}


        <div className='joystick-container'></div>
        <h1 style={{display:'none'}}>Estadio Aguila</h1>
        <canvas id='canvas-home'></canvas>

      </section>

    </>
  )
}

export default App